if (!window.Eurus.loadedScript.has("product-tabs.js")) {
  window.Eurus.loadedScript.add("product-tabs.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      // Tab navigation component for arrow buttons
      Alpine.data("xTabNavigation", (sectionId, totalTabs) => ({
        sectionId: sectionId,
        totalTabs: totalTabs,
        currentTab: 0,

        init() {
          // Find the parent xProductTabs component and sync with its 'open' value
          this.$nextTick(() => {
            const productTabsContainer = document.querySelector('[x-data*="xProductTabs"]');
            if (productTabsContainer) {
              // Watch the 'open' variable from xProductTabs component
              this.$watch(() => {
                // Access Alpine data from the container
                const alpineData = Alpine.$data(productTabsContainer);
                return alpineData ? alpineData.open : 0;
              }, (value) => {
                this.currentTab = value;
              });

              // Initialize with current value
              const alpineData = Alpine.$data(productTabsContainer);
              if (alpineData) {
                this.currentTab = alpineData.open;
              }
            }

            // Apply tab alignment based on overflow state
            this.updateTabAlignment();

            // Update alignment on window resize
            window.addEventListener('resize', () => {
              this.updateTabAlignment();
            });
          });
        },

        updateTabAlignment() {
          const tabsContainer = document.querySelector('.tabs-' + this.sectionId);
          if (!tabsContainer) return;

          const isOverflowing = tabsContainer.scrollWidth > tabsContainer.clientWidth;

          if (isOverflowing) {
            tabsContainer.classList.add('is-scrollable');
            tabsContainer.classList.remove('no-overflow');
          } else {
            tabsContainer.classList.remove('is-scrollable');
            tabsContainer.classList.add('no-overflow');
          }
        },

        nextTab() {
          if (this.currentTab < this.totalTabs - 1) {
            const newIndex = this.currentTab + 1;
            this.triggerTabClick(newIndex);
          }
        },

        previousTab() {
          if (this.currentTab > 0) {
            const newIndex = this.currentTab - 1;
            this.triggerTabClick(newIndex);
          }
        },

        triggerTabClick(tabIndex) {
          // Find all tab items and click the one at the specified index
          const tabItems = document.querySelectorAll('.product-tab .tab-item');
          if (tabItems[tabIndex]) {
            tabItems[tabIndex].click();

            // Auto-scroll the tab into view in the tab titles bar
            this.$nextTick(() => {
              this.scrollTabIntoView(tabItems[tabIndex]);
            });
          }
        },

        scrollTabIntoView(tabElement) {
          if (!tabElement) return;

          // Find the scrollable container (tabs bar)
          const tabsContainer = tabElement.closest('.tabs-' + this.sectionId);
          if (!tabsContainer) return;

          // Get the tab's position relative to the container
          const tabRect = tabElement.getBoundingClientRect();
          const containerRect = tabsContainer.getBoundingClientRect();

          // Calculate if the tab is outside the visible area
          const isLeftOutside = tabRect.left < containerRect.left;
          const isRightOutside = tabRect.right > containerRect.right;

          if (isLeftOutside || isRightOutside) {
            // Scroll the tab into view with smooth behavior
            tabElement.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center'
            });
          }
        }
      }));

      Alpine.data("xProductTabs", () => ({
        open: 0,
        openMobile: false,
        tabActive: '',

        setTabActive() {
          const tabActive = this.$el.dataset.tabtitle;
          this.tabActive = tabActive;
        }
      }));

      // Swipe functionality for mobile/tablet (non-dropdown layout)
      Alpine.data("xTabSwipe", (sectionId) => ({
        sectionId: sectionId,
        touchStartX: 0,
        touchStartY: 0,
        touchEndX: 0,
        touchEndY: 0,
        minSwipeDistance: 50,

        handleTouchStart(e) {
          // Only handle swipe on mobile/tablet, not desktop
          if (window.innerWidth >= 768) return;

          this.touchStartX = e.changedTouches[0].screenX;
          this.touchStartY = e.changedTouches[0].screenY;
        },

        handleTouchMove(e) {
          // Only handle swipe on mobile/tablet, not desktop
          if (window.innerWidth >= 768) return;

          this.touchEndX = e.changedTouches[0].screenX;
          this.touchEndY = e.changedTouches[0].screenY;
        },

        handleTouchEnd() {
          // Only handle swipe on mobile/tablet, not desktop
          if (window.innerWidth >= 768) return;

          const deltaX = this.touchEndX - this.touchStartX;
          const deltaY = this.touchEndY - this.touchStartY;

          // Check if horizontal swipe is more significant than vertical
          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > this.minSwipeDistance) {
            // Get current tab from the xProductTabs component
            const productTabsContainer = document.querySelector('[x-data*="xProductTabs"]');
            if (productTabsContainer) {
              const alpineData = Alpine.$data(productTabsContainer);
              const currentTab = alpineData ? alpineData.open : 0;
              const tabItems = document.querySelectorAll('.product-tab .tab-item');
              const totalTabs = tabItems.length;

              if (deltaX > 0) {
                // Swipe right - go to previous tab
                if (currentTab > 0 && tabItems[currentTab - 1]) {
                  tabItems[currentTab - 1].click();
                }
              } else {
                // Swipe left - go to next tab
                if (currentTab < totalTabs - 1 && tabItems[currentTab + 1]) {
                  tabItems[currentTab + 1].click();
                }
              }
            }
          }
        }
      }));
    });
  });
}
